export default function remapProps(source, propsMap) {
  const obj = { ...source };
  for (const oldPropName of Object.keys(propsMap)) {
    obj[oldPropName] = source[propsMap[oldPropName]];
    delete obj[propsMap[oldPropName]];
  }
  return obj;
}
